import CoreApi from '@/api/coreApi'

export const coreApi = new CoreApi()
